import dayjs from "dayjs";
import Util from '../Common/Util';

/**
 * 연락처, 내소속기사 선택하는 팝업 (BS self-contained)
 *
 * 호출:
 *   $j.Ui.BS.open({
 *       target: '$j.F.ModalPhone',
 *       data: {
 *           $p: { why, from, car_price, is_fee, isFeeEditDisable, isRecentDisable, ordernum },
 *           onApply: ($r) => { ... }
 *       }
 *   });
 *
 * $p [입력]
 *   why : 어떤 용도로 호출했냐 ( 거래처, 현장, 연락처, 수주자, 소속자, 지정 )
 *   from : 어느페이지에서 호출했냐 ( 일지, 수주, 발주 )
 *   car_price : 장비대금( 수수료 있을때 )
 *   is_fee : 수수료여부
 *   isFeeEditDisable : 수수료 변경 불가 여부
 *   isRecentDisable : 최근통화목록 비활성화 여부
 *
 * $r [출력 — onApply 콜백 인자]
 *   1) 공통정보 => 회원조회결과 (order_type -> '91':소속자, '95':타회원, '94':비회원 )
 *   2) 연락처 => 전화번호(hp),이름(hp_name)
 *   3) 내소속기사 => 기사회원번호(worker_num), 기사이름(worker_name), 차량PK(worker_carnum), 차량번호(worker_carplate)
 *   4) 발주정보 => 수수료여부(is_fee), 지정한회원번호(worker_num), 캐시잔액 부족(no_cash)
 */
/** 글자 자르기 — 연락처 목록의 이름칸(10자)에만 쓴다 */
function cutStr(text, maxLength, suffix = '...') {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + suffix : text;
}

/** 날짜를 오늘/어제/그저께로. 그 이전은 원본 그대로 돌려준다 */
function getSimpleDay(date) {
    const diff = dayjs().diff(date, 'day');
    if (diff === 0) return '오늘';
    if (diff === 1) return '어제';
    if (diff === 2) return '그저께';
    return date;
}

export default class PhoneModal {
    constructor() {
        this.id = null;
        this.parent = null;
        this.data = null;
        this.timeout = null; // 디바운싱 처리를 위한 변수
    }

    init() {
        if (!this.data) this.data = {};
        if (!this.data.$p) this.data.$p = {};
        this.data.$r = {};
        this.isRecentGet = false;
        this.isExistRecent = false;
        this.isCars = false;
        this.kwd = '!';
        this.tabIndex = 1;

        // why 별 BS 헤더 타이틀
        const titleMap = {
            '소속자':  '소속자',
            '수주자':  '수주자',
            '지정':    '지정',
            '거래처':  '거래처',
            '현장':    '현장',
            '연락처':  '연락처',
        };
        this.parent?.setTitle?.(titleMap[this.data.$p?.['why']] || '연락처');

        // skeleton 을 동기 렌더링한다. AJAX 로 HTML 을 받아오는 방식이면 BS slide-up
        // 도중에 패널 높이가 점프하면서 transform: translate(-50%,100%) 의 % 가
        // 재계산돼 꿀렁이는 현상이 발생. 정적 구조를 미리 그려 패널 높이를 확보하고
        // recent/cars 데이터만 비동기로 채운다.
        const wrapId = 'window-phone';
        $('#' + this.id).html(`<div id="${wrapId}">${this.skeletonHtml()}</div>`);
        this.id = wrapId;

        this.initTop();
        this.initBody();
        this.initHandler();
    }

    skeletonHtml() {
        const onestoreUrl = (typeof G5 !== 'undefined' && G5['ONESTORE_URL']) || '';
        return `
<div class="flex_column modal_content">
    <nav class="num_my_lab">
        <ul id="ul-list" class="ul-list division--3">
            <li>
                <a data-index="1" class="tabBtn on" href="#">연락처</a>
            </li>
            <li>
                <a data-index="2" class="tabBtn" href="#">내 소속기사</a>
            </li>
        </ul>
    </nav>

    <div id="modal_phone_tab1" class="tabContent box_wrap flex_column recent_call_log on">
        <div class="send_wrap flex">
            <div id="modal_phone_direct" class="direct_input">
                <div class="name_box" style="display: none">
                    <span id="modal_phone_name">홍길동</span>
                </div>
                <input type="text" placeholder="직접입력" id="modal_phone_num1" maxlength="18" autocomplete="off">
                <div class="magnify flex">
                    <button id="address-book">
                        <i class="fas fa-address-book"></i>
                        <p>주소록검색</p>
                    </button>
                    <button class="del_btn" id="modal_phone_delete" style="display: none"><i class="fas fa-times"></i></button>
                </div>

                <div id="modal_phone_search" class="search_bar search">
                    <div id="modal_phone_search1" class="recent_use_content">
                        <div class="title">최근이용기록</div>
                        <ul></ul>
                        <div></div>
                    </div>

                    <div id="modal_phone_search2" class="search_results_content">
                        <div class="title">검색결과</div>
                        <ul></ul>
                        <div></div>
                    </div>

                </div>
            </div>

            <div class="modal_button modal_phone_apply flex" id="modal_phone_apply">
                <a href="javascript:void(0)" class="js-phone-apply"><button class="button_yellow">적용</button></a>
            </div>
        </div>

        <div class="charge_wrap" id="modal_phone_fee_area">
            <p>수수료</p>
            <div>
                <div>
                    <input type="radio" name="modal_phone_fee" checked value="1">
                    <label>있음</label>
                </div>
                <div>
                    <input type="radio" name="modal_phone_fee" value="0">
                    <label>없음</label>
                </div>
            </div>
        </div>

        <div id="modal_phone_recent" class="recently_call">
            <div class="title flex">
                <div><img src="/img/sign/round_triangle.png" alt="triangle"></div>
                <div class="fw_bolder" id="modal_phone_recent_title">최근통화기록</div>
            </div>
            <div id="modal_phone_content1" class="content ok_ak">
                <div id="modal_phone_content11" class="no_akduck_content flex_column h100">
                    <div style="display:block;">
                        <p class="fz_12 t_c fw_bolder">'최근 통화기록' 가져오기는</p>
                        <p class="fz_12 t_c fw_bolder">악덕알리미 설치 이후 가능합니다.</p>
                    </div>
                    <!-- 새 앱(openApp)은 앱이 설치 안내 웹(/devil-install)을 앱 밖 브라우저로 연다 — 앱 화면에 스토어 이름·링크를 두지 않는다(구글 정책).
                         구앱·PC 는 종전대로 원스토어 웹 링크. 분기는 onClickInstallAkduck -->
                    <button type="button" id="modal-phone-install-akduck" class="button_yellow_no" data-store="${onestoreUrl}">악덕알리미 앱 설치하기</button>
                    <div class="no_ak_txtbox">
                        <i><img src="/img/akduck_logo.png" alt="악덕"></i>
                        <div class="txt">
                            <span>'악덕알리미' 앱 설치 시 특장점</span>
                            <span>· 전화가 걸려올때 악덕업체 등록이 되어 있는지 사전에 확인이 가능합니다.</span>
                            <span>· (검색, 등록도 가능)</span>
                        </div>
                    </div>
                </div>
                <div id="modal_phone_content12" class="ok_akduck_content">
                    <ul id="modal_phone_recent_list" class="recent_lists"></ul>
                </div>
                <div id="modal_phone_content13" class="ok_akduck_content used_content" style="display:none">
                    <ul id="modal_phone_used_list" class="recent_lists"></ul>
                    <div id="modal_phone_used_empty" class="used_empty" style="display:none">
                        <p>최근 이용한 연락처가 없습니다.</p>
                        <p>위 칸에 번호를 직접 입력해 주세요.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="modal_phone_tab2" class="tabContent box_wrap flex_column my_select">
        <div class="modal_phone_box">
            <div class="title_box">
                <h3>01 소속기사</h3>
                <h3>02 소유차량</h3>
            </div>
            <div class="list_box">
                <ul id="modal_phone_drivers"></ul>
                <ul id="modal_phone_cars"></ul>
            </div>
        </div>
    </div>
</div>`;
    }

    destroy() {
        $('#' + this.id).off();
    }

    // 상단 메뉴 영역 그리기
    initTop = function(){
        const why = this.data.$p['why'];// 어떤 용도로 호출했나? (거래처,현장, 연락처, ...)
        const from = this.data.$p['from']; // 어느페이지에서 호출했나? 
        const self = this;
        if( why=='소속자'){
            self.tabIndex=2;
        }

        // why 값이 수주자,지정일때는 모든탭 다 나오게 하고, 나머지의 경우 탭 하나만 나오게한다.
        $('#' + self.id + ' .tabBtn').each(function () {
            // 연락처 탭
            if ($(this).attr('data-index') == 1) {
                if(['거래처','현장','연락처'].includes(why)){
                    $(this).parent().show();
                    $(this).addClass('on');
                }else if(['소속자'].includes(why) ){
                    $(this).parent().hide();
                    $(this).removeClass('on');
                }
            }
            // 내소속기사 탭
            else {
                if(['거래처','현장','연락처'].includes(why) || MEMBER['mem_driver_type']!='수발주자') {
                    $(this).parent().hide();
                    $(this).removeClass('on');
                }else if(['소속자'].includes(why) ){
                    $(this).parent().show();
                    $(this).addClass('on');
                }
            }
        });

        // 탭이 하나만 보이면 BS 헤더 타이틀과 중복되므로 텍스트는 숨기고 노란 underline 만 남긴다.
        const $nav = $('#' + self.id + ' .num_my_lab');
        const visibleTabCount = $nav.find('li:visible').length;
        if (visibleTabCount <= 1) {
            $nav.addClass('nav-line-only');
        } else {
            $nav.removeClass('nav-line-only');
        }
    }

    // 본문영역 그리기
    initBody = function(){
        const why = this.data.$p['why'];
        const from = this.data.$p['from'];

        if( ['소속자'].includes(why)){
            this.showBody([2]);
        }else{
            this.showBody([1]);
        }
        const self = this;

        if( ['거래처','현장','연락처','수주자','지정'].includes(why)){
            this.initPhone();
        }
        else if( ['소속자'].includes(why)){
            this.initCars();
        }
        // else if( ['지정'].includes(why)){
        //     this.initJijung();
        // }

        // 일지/발주 등에서 호출된경우 수수료 선택 영역이 보이게 한다.
        if( !this.data.$p['isFeeEditDisable'] && ( (from=='일지' && ['소속자','수주자'].includes(why)) || (from=='발주' && ['지정'].includes(why)) ) ){
            $('#modal_phone_fee_area').css('display', 'flex');
            if (this.data.$p['is_fee'] !== undefined) {
                $('input[name="modal_phone_fee"][value="' + this.data.$p['is_fee'] + '"]').prop('checked', true);
            }
        }

        // 주소록 : 동기화 시간 표시
        // if(MEMBER['contact_sync_date']) {
        //     const syncText='최근 동기화 '+dayjs(MEMBER['contact_sync_date']).format('YYYY-MM-DD HH:mm');
        //     $('#modal_phone_sync_date').html(syncText);
        // }
    }

    // 최근통화 영역 초기화
    initPhone = function(){
        // 앱마켓 심사용 계정(/adm/config store_test_mbno → G5.STORE_TEST)에게는 최근통화기록 영역(악덕알리미 설치 안내 포함)을
        // 통째로 숨긴다 — 예전엔 회원번호 9739 를 박아 두어 관리자에서 계정을 바꾸면 따라가지 않았다(9/30).
        if( G5['STORE_TEST'] ) {
            $('#modal_phone_recent').hide();
            return;
        }
        if( !this.data.$p['isRecentDisable']){
            this.getRecent();
            return;
        }
        // 최근통화기록을 못 쓰는 회원(발주자)은 이 영역이 접힌 채로 남아 BS 가 입력칸 한 줄 높이로
        // 뜬다 — 열다 만 것처럼 보여 오류로 오해받는다. 대신 '최근이용기록'(내가 예전에 넣었던
        // 거래처/현장 번호)을 같은 자리에 펼쳐 준다. 높이는 skeleton 단계에서 미리 확보하고
        // (BS slide-up 중 높이 점프 방지) 목록만 비동기로 채운다.
        this.showUsed();
        this.getUsed();
    }

    // 최근지정발주 영역초기화
    // initJijung = function(){
    //     this.getJijung();
    // }

    // 내차량, 소유자 영역 초기화
    initCars = function(){
        this.getCars();
    }

    /**
     * 악덕알리미 설치하기 버튼 클릭 (최근통화기록이 비어 있을 때의 설치 안내)
     * — 새 앱(openApp 지원)이면 앱이 설치 안내 웹(/devil-install)을 앱 밖 브라우저로 열고, 그새 설치돼 있으면 앱을 연다.
     *   구앱·PC 브라우저는 종전대로 원스토어 웹 링크(새 창). 연결 페이지(RelationDevilApp)와 같은 흐름. (2026-09-30)
     */
    onClickInstallAkduck = function(e){
        e.stopPropagation();
        if( $j.F.App.devilAppSupported() ){
            $j.F.App.openDevilApp({ fallback: location.origin + '/devil-install' });
            return;
        }
        const store = $(e.currentTarget).data('store');
        if( store ) window.open(store, '_blank');
    }

    /**
     * 이벤트 핸들러등록
     * off -> on 하는 이유는 윈도우여러번 닫았다 띄웠다 하면 핸들러가 중첩될수있기때문에 기존핸들러를 제거하기위함이다.
     */
    initHandler = function(){
        const self = this;
        const $root = $('#' + this.id);

        // 아무데나 클릭하면 열려있던 팝업 닫히게
        $root.on('click.phone', function(){
            self.closePopup();
        });

        $root.on('click.phone', '.cancel_btn', function(e){
            e.stopPropagation();
            self.parent.close();
        });

        // 악덕알리미 설치하기 버튼 클릭
        $root.on('click.phone', '#modal-phone-install-akduck', this.onClickInstallAkduck);

        // 상단 (연락처,내소속기사) 메뉴 클릭 핸들러
        $root.on('click.phone', '.tabBtn', function(e){
            e.stopPropagation();
            const idx = $(this).attr('data-index');
            if( self.tabIndex==idx) return;
            self.tabIndex=idx;
            $root.find('.tabBtn').removeClass('on');
            $(this).addClass('on');
            if( idx==1){
                $('#modal_phone_tab1').addClass('on');
                $('#modal_phone_tab2').removeClass('on');
            }else{
                $('#modal_phone_tab1').removeClass('on');
                $('#modal_phone_tab2').addClass('on');
                self.getCars();
            }
        });

        // 검색어입력칸 클릭 or 키업 핸들러
        $root.on('click.phone input.phone', '#modal_phone_num1', function(e){
            e.stopPropagation();
            self.showSearch();
            self.getSearch();
        });

        // 연락처(주소록) 버튼 클릭
        $root.on('click.phone', '#address-book', function(e){
            e.stopPropagation();
            $j.F.App.openAddressBook();
        });
        $root.on('click.phone', '#modal_phone_delete', function(e){
            e.stopPropagation();
            $('#modal_phone_name').html('').parent().hide();
            $('#modal_phone_num1').val('');
            $('#modal_phone_delete').hide();
            $('#address-book').show();
        });

        // 적용 버튼
        $root.on('click.phone', '.js-phone-apply', function(e){
            e.stopPropagation();
            self.applyPhone();
        });

        // 통화목록/검색결과의 항목 클릭 (selectPhone)
        $root.on('click.phone', '.js-select-phone', function(e){
            e.stopPropagation();
            const phone = $(this).data('phone');
            const name  = $(this).data('name') || '';
            const apply = $(this).data('apply') == 1;
            self.selectPhone(String(phone), String(name), apply);
        });

        // 소속기사 선택
        $root.on('click.phone', '.js-select-driver', function(e){
            e.stopPropagation();
            self.selectDriver(this);
        });

        // 소유차량 선택
        $root.on('click.phone', '.js-select-car', function(e){
            e.stopPropagation();
            self.selectCar(this);
        });
    }


    /**
     * 번호선택
     * @param phone 전화번호
     * @param name 이름
     * @param isApply 적용여부
     */
    selectPhone = function(phone,name='', isApply=false){
        $('#modal_phone_num1').val(phone).data('phone',phone).data('name', name);
        this.data.$r['hp']=Util.phoneNumber(phone);
        this.data.$r['hp_name']=name;
        if( isApply ) {
            this.closePopup();
            this.applyPhone();
        }else{
            this.showSearch();
            console.log(name);
            $('#modal_phone_name').text(name).parent().show();
            $('#address-book').hide();
            $('#modal_phone_delete').show();
        }
    }
    /**
     * 소속기사 선택
     * @param el
     */
    selectDriver = function(el){
        $('#modal_phone_drivers button').removeClass('on');
        $(el).addClass('on');

        $('#modal_phone_apply button').removeClass('no_act').addClass('act');

        this.data.$r['worker_num']=$(el).attr('data-value');
        this.data.$r['worker_name']=$(el).attr('data-name');

        this.applyCar();
    }
    /**
     * 소유차량 선택
     * @param el
     */
    selectCar = function(el){
        $('#modal_phone_cars button').removeClass('on');
        $(el).addClass('on');

        $('#modal_phone_apply button').removeClass('no_act').addClass('act');
        // $('#modal_phone_apply .applied_car').html($(el).attr('data-name'))

        this.data.$r['worker_carnum']=$(el).attr('data-value');
        this.data.$r['worker_carplate']=$(el).attr('data-name');

        this.applyCar();
    }

    apply = function(){
        const self = this;
        let html = '';
        if( self.data.$r['order_type']==91){
            const carPlate = Util.nvl(self.data.$r['worker_carplate'], self.data.$r['hp']);
            html = `<div class="toast-select-done">
            <h3>선택완료</h3>
            <span class="worker_name">${Util.escapeHtml(self.data.$r['worker_name'])}</span>
            <span class="worker_carplate">${Util.escapeHtml(carPlate)}</span>
            </div>`;
        }else{
            html = `<div class="toast-select-done">
            <h3>선택완료</h3>
            <span class="worker_name">${Util.escapeHtml(Util.nvl(self.data.$r['hp_name'],'이름없음'))}</span>
            <span class="worker_carplate">${Util.escapeHtml(self.data.$r['hp'])}</span>
            </div>`;
        }
        if( self.data.$p['from']=='발주' ) $j.Ui.Toast.show(html, { html:true, timeout:3000, closable:true });

        const cb = self.data?.onApply;
        self.parent.close();
        if (typeof cb === 'function') cb(self.data.$r);
    }

    /**
     * 연락처 적용
     */
    applyPhone = function(){
        const self=this;
        let hp = $('#modal_phone_num1').val();
        hp = hp.replace(/\D/g, '');//숫자만 추출
        if(!hp || hp.length<8) {
            Util.swalert('올바른 연락처를 입력해주세요');
            return;
        }
        this.data.$r['hp']=Util.phoneNumber(hp);
        let p = this.data.$p['car_price'];
        if(!p) p=0;

        let is_fee = $("input[name='modal_phone_fee']:checked").val();
        this.data.$r['is_fee']=is_fee;

        // TODO : 아래 로직은 수정할 필요가 있다. 발주할때만 회원조회를 하지 그외에는 필요가 없으니깐
        // console.log(this.data.$p['hp'], this.data.$p['hp_name']);
        // 선택한 폰이 회원인지 체크
        $.ajax({
            url: '/m/ajax/member/find/phone',
            type: 'get',
            data: {
                hp,
                car_price : p
            },
            dataType: 'json',
            success: function(data){
                const result = data['result']; // 91:소속자, 95:타회원, 94:비회원
                self.data.$r['order_type']=result;
                if(['91','95'].includes(result)){
                    self.data.$r['worker_num']=data['mb_no'];
                    self.data.$r['hp_name']=data['mem_name'];
                    self.data.$r['worker_name']=data['mem_name'];
                    self.data.$r['no_cash']=data['no_cash'];
                    // $j.Ui.Window.update(self.id, self.data);
                    self.apply();
                }
                else{
                    // 발주자,업체발주자는 비회원에게 발주할수 없다.
                    if( MEMBER['mem_driver_type']!='수발주자' && !G5['isAdmin']){
                        Util.swalert('장비불러! 회원이 아닙니다.  지정불가...!');
                        return;
                    }
                    // 외부발주인데 이름을 입력안했다면
                    if( ['수주자','지정'].includes(self.data.$p['why']) && !self.data.$r['hp_name']) {
                        self.queryName();

                    }else{
                        // $j.Ui.Window.update(self.id, self.data);
                        self.apply();
                    }
                }

            }
        });
    }
    queryName = async function(){
        const self = this;
        const who = await $j.Ui.Dialog.prompt('이름을 입력해주세요.', { placeholder: '이름' });
        if (who) {
            self.data.$r['hp_name']=who;
            // $j.Ui.Window.update(self.id, self.data);
            self.apply();
        }
    }

    /**
     * 소속자,소속차량 적용
     */
    applyCar = function(){
        if(!this.data.$r['worker_num'] || !this.data.$r['worker_carnum']) return;

        this.data.$r['order_type']='91';// 소속자
        // $j.Ui.Window.update(this.id, this.data);
        this.apply();
    }
    /**
     * 열려있는 모든 창을 닫는다.
     */
    closePopup = function(){
        this.hideSearch();
    }
    /**
     * 연락처에서 초성에 해당하는 위치로 스크롤을 옮긴다.
     * @param cho 초성
     */
    // scrollToCho = function(cho){
    //     let $el = $('#modal_phone_contact_list');
    //     $el.scrollTop(0);
    //     let h = $el.offset().top;
    //     if( cho=='Z') cho='123ABC';
    //     $('#modal_phone_contact_list .consonant').each(function(){
    //         if(cho==$(this).html()){
    //             // console.log(cho, '--->',$(this).offset().top);
    //             h = $(this).offset().top-h;
    //             $el.scrollTop(h);
    //         }
    //     })
    // }

    /**
     * 소속기사,소유차량 가져오기
     */
    getCars = function(){
        if( this.isCars) return;
        const $p = this.data.$p;
        const self=this;
        // 기종매칭 기준: 현재 선택값($p.car_type 등) 우선, 없으면 서버가 ordernum 으로 폴백
        $.ajax({
            url: '/m/ajax/cars/list',
            type: 'get',
            data: {
                ordernum:   $p['ordernum'],
                car_type:   $p['car_type'],
                car_range:  $p['car_range'],
                car_option: $p['car_option'],
                car_height: $p['car_height'],
            },
            dataType: 'json',
            success: function(data){
                self.renderCars(data);
                self.isCars = true;
            }
        });
    }

    /**
     * 최근이용 표시
     */
    getSearch = function(){
        const self=this;
        const kwd = $('#modal_phone_num1').val();
        if(kwd) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                self.search();
            }, G5['DEBOUNCE_TIME']);
        }
        else{
            self.search();
        }
    }
    search(){
        const self=this;
        const kwd = $('#modal_phone_num1').val();

        $.ajax({type : 'get',
            url : '/m/ajax/phone/search',
            data:{kwd},
            success : function (list){
                self.renderUse(list);
            }
        });
    }


    /**
     * 최신통화 목록
     */
    getRecent = function(){
        const self = this;
        if( this.isRecentGet ) {
            self.showRecent();
            return;
        }

        let adr = '/m/ajax/call/recent';
        $.ajax({
            url: adr,
            type: 'get',
            data: {
                'uid':MEMBER['mem_phone']
            },
            dataType: 'json',
            success: function(list){
                self.isRecentGet = true;
                // if(list.length==0){// 최근통화기록이 없다면
                //     self.getContact(); // 연락처 가져오기
                //     return;
                // }
                self.isExistRecent=list.length>0;
                self.renderRecent(list);
                self.showRecent();
            }
        });
    }

    /**
     * 최근이용 목록 (내가 이전에 입력했던 거래처/현장 번호)
     * — 최근통화기록을 못 쓰는 회원(발주자)에게 그 자리에 대신 보여준다.
     */
    getUsed = function(){
        const self = this;
        $.ajax({
            url: '/m/ajax/phone/search',
            type: 'get',
            data: { kwd: '' },
            dataType: 'json',
            success: function(list){
                self.renderUsed(list || []);
            }
        });
    }
    /**
     * 연락처(주소록) 목록
     * @param isForce 무조건리프레시
     */
    // getContact = function (isForce=false){
    //     const self = this;
    //     if( this.isContactGet && !isForce ) {
    //         self.showContact();
    //         return;
    //     }
    //
    //     let adr = '/m/ajax/contact/list';
    //     $.ajax({
    //         url: adr,
    //         type: 'get',
    //         data: {
    //             'uid': MEMBER['mem_phone']
    //         },
    //         dataType: 'json',
    //         success: function (list) {
    //             self.isContactGet = true;
    //             if( list.length==0){ // 최근통화X,연락처X
    //                 if( self.data.$p['isRecentDisable']==true){
    //                     self.showContact();
    //                 }else {
    //                     self.showRecent();
    //                 }
    //
    //                 return;
    //             }
    //             self.isExistContact=true;
    //             self.showContact();
    //             self.renderContact(list);
    //         }
    //     });
    // }
    showBody = function(list){
        // console.log(list);
        $('#'+this.id+' .tabContent').removeClass('on');
        if( list.includes(1)) $('#modal_phone_tab1').addClass('on');
        if( list.includes(2)) $('#modal_phone_tab2').addClass('on');
    }

    /**
     * 검색결과 영역 표시
     */
    showSearch = function(){
        $('#modal_phone_direct').addClass('on');
        // $('#modal_phone_apply').show();
        $('#modal_phone_search').removeClass('search');
        $('#modal_phone_search').addClass('recent');
        // const kwd = $('#modal_phone_num1').val();
        //
        // if(kwd) {
        //     $('#modal_phone_direct').removeClass('on');
        //     $('#modal_phone_apply').show();
        //     $('#modal_phone_search').removeClass('recent');
        // }
        // else {
        //     $('#modal_phone_direct').addClass('on');
        //     $('#modal_phone_apply').hide();
        //     $('#modal_phone_search').removeClass('search');
        //     $('#modal_phone_search').addClass('recent');
        // }
    }
    // 검색결과 영역 닫기
    hideSearch = function(){
        $('#modal_phone_direct').removeClass('on');
    }
    // showJijung = function(){
    //     if( $('#modal_phone_jijung').hasClass('on') ) return;
    //     $('#modal_phone_jijung').addClass('on');
    // }
    // hideJijung = function(){
    //     $('#modal_phone_jijung').removeClass('on');
    // }
    /**
     * 최근통화 영역 열기
     */
    showRecent = function(){
        if( $('#modal_phone_recent').hasClass('on') ) return;
        $('#modal_phone_recent').addClass('on');

        // console.log(1111, this.isExistRecent);
        if(this.isExistRecent){
            $('#modal_phone_content1').removeClass('no_ak_sync').addClass('ok_ak');
            $('#modal_phone_content11').hide();
            $('#modal_phone_content12').show();
        }else{
            // 악덕알리미 설치 안내표시
            $('#modal_phone_content1').removeClass('ok_ak').addClass('no_ak_sync');
            $('#modal_phone_content11').show();
            $('#modal_phone_content12').hide();
        }
    }
    // hideRecent = function(){
    //     $('#modal_phone_recent').removeClass('on')
    // }
    /**
     * 최근이용 영역 열기 (최근통화기록 자리를 그대로 쓴다)
     */
    showUsed = function(){
        $('#modal_phone_recent_title').text('최근이용기록');
        $('#modal_phone_content1').removeClass('no_ak_sync').addClass('ok_ak');
        $('#modal_phone_content11').hide();
        $('#modal_phone_content12').hide();
        $('#modal_phone_content13').show();
        $('#modal_phone_recent').addClass('on');
    }
    /**
     * 연락처 영역 열기
     * @param isForce 무조건 리프레시
     */
    // showContact = function(isForce=false){
    //     if( $('#modal_phone_contact').hasClass('on') && !isForce ) return;
    //     $('#modal_phone_contact').addClass('on');
    //
    //     if(this.isExistContact){
    //         $('#modal_phone_content2').removeClass('no_ak_sync').addClass('ok_sync');
    //         $('#modal_phone_content21').hide();
    //         $('#modal_phone_content22').show();
    //     }else{
    //         // 연락처 동기화 안내표시
    //         $('#modal_phone_content2').addClass('no_ak_sync').removeClass('ok_sync');
    //         $('#modal_phone_content21').show();
    //         $('#modal_phone_content22').hide();
    //     }
    // }
    // hideContact = function(){
    //     $('#modal_phone_contact').removeClass('on');
    // }


    /**
     * 최신통화 목록 그리기
     * @param list
     */
    renderRecent = function(list){
        const tplDate = `
<li class="date flex">
    <span class="day fw_bold">{dt} {yoil}</span>
    <div class="line flex"></div>
</li>`;
        const tpl = `{dateline}
<li class="list">
    <div class="list_group flex_space_between js-select-phone" data-phone="{number}" data-name="{who}" data-apply="1">
        <div class="left user_img flex">{gubun}</div>
        <div class="right flex_space_between">
            <div class="people_info flex_column">
                <div class="{ak} flex">
                    <div class="name fw_bolder">{who1}</div>
                    <div class="ak_mark">악덕</div>
                </div>
                <div class="number fw_bolder">{who2}</div>
            </div>
            <div class="call_info flex_column">
                <div class="means flex">{icon}</div>
                <div class="time fw_bolder">{time}</div>
            </div>
        </div>
    </div>
</li>
        `;
        let html = '';
        let prev_date='';
        list.forEach((row)=>{
            // TODO : 날짜가 변경되었을때, 오늘/어제 는 별도로 처리
            let dt = dayjs(row.call_date).format('YYYY-MM-DD');
            let dateline='';
            if( prev_date!=dt ){
                dateline=Util.render_template(tplDate, {'dt': getSimpleDay(dt), 'yoil':Util.getYoil(dt)});// TODO : 어제, 그저께, 년월일...분기처리
                prev_date=dt;
            }

            let gubun = `<img src="/img/sign/user_mark.png" alt="ak">`;
            let ak='';
            if(row.is_bad=='1'){
                gubun=`<img src="/img/sign/ak_mark.png" alt="ak">`;
                ak='ak';
            }
            let time = dayjs(row.call_date).format('A hh:mm');
            time=time.replace('AM','오전').replace('PM','오후');
            let who1 = '';
            let who2 = '';
            if( row.name=='미지정' || !row.name) {
                who1 = '연락처 미등록';
            }else{
                who1 = Util.escapeHtml(cutStr(row.name,10));
            }
            who2 = Util.phoneNumber(row.phone);

            let icon='';
            switch (row.gubun){
                case '1'://수신
                    icon=`<img class="call_receive" src="/img/sign/call_receive.png" alt="call_receive">`;
                    break;
                case '2'://발신
                    icon=`<img class="call_call" src="/img/sign/call_call.png" alt="call_call">`;
                    break;
                case '3'://부재중
                    icon=`<img class="call_miss" src="/img/sign/call_miss.png" alt="callmiss">`;
                    break;
                case '4'://부재중
                    icon=`<img class="call_ongoing" src="/img/sign/call_ongoing.png" alt="call_ongoing">`;
                    break;
            }

            let data = {
                'dateline': dateline,
                'gubun': gubun,
                'ak':ak,
                'who1': who1,
                'who2': who2,
                'who' : Util.escapeHtml(row.name),
                'icon': icon,
                'time': time,
                'number': Util.phoneNumber(row.phone)
            };
            html += Util.render_template(tpl,data);
        });
        $('#modal_phone_recent_list').html(html);
    }
    /**
     * 최근이용 목록 그리기 (최근통화기록과 같은 리스트 모양, 통화방향 아이콘만 없다)
     * @param list
     */
    renderUsed = function(list){
        const tplDate = `
<li class="date flex">
    <span class="day fw_bold">{dt} {yoil}</span>
    <div class="line flex"></div>
</li>`;
        const tpl = `{dateline}
<li class="list">
    <div class="list_group flex_space_between js-select-phone" data-phone="{number}" data-name="{who}" data-apply="1">
        <div class="left user_img flex"><img src="/img/sign/user_mark.png" alt="user"></div>
        <div class="right flex_space_between">
            <div class="people_info flex_column">
                <div class="flex"><div class="name fw_bolder">{who1}</div></div>
                <div class="number fw_bolder">{who2}</div>
            </div>
            <div class="call_info flex_column">
                <div class="time fw_bolder">{time}</div>
            </div>
        </div>
    </div>
</li>`;

        if( !list.length ){
            $('#modal_phone_used_list').html('');
            $('#modal_phone_used_empty').show();
            return;
        }
        $('#modal_phone_used_empty').hide();

        let html = '';
        let prev_date = '';
        list.forEach((row)=>{
            const dt = dayjs(row.datetime).format('YYYY-MM-DD');
            let dateline = '';
            if( prev_date != dt ){
                dateline = Util.render_template(tplDate, {'dt': getSimpleDay(dt), 'yoil': Util.getYoil(dt)});
                prev_date = dt;
            }
            let time = dayjs(row.datetime).format('A hh:mm');
            time = time.replace('AM','오전').replace('PM','오후');

            html += Util.render_template(tpl, {
                'dateline': dateline,
                'who1': row.cont_name ? Util.escapeHtml(cutStr(row.cont_name, 10)) : '이름없음',
                'who2': Util.phoneNumber(row.cont_cel),
                'who' : Util.escapeHtml(row.cont_name),
                'time': time,
                'number': Util.phoneNumber(row.cont_cel),
            });
        });
        $('#modal_phone_used_list').html(html);
    }
    /**
     * 최근 지정발주 기록 그리기
     * @param list
     */
    // renderJijung = function(list){
    //     let tpl = `<div class="name_phone flex_space_between" onclick="$j.Ui.Window.handle.selectPhone('{mem_phone}','{mem_name}')">
    //                             <div class="name flex fz_13 fw_bolder">{mem_name}</div>
    //                             <div class="phone flex fz_13 fw_bolder">{mem_phone}</div>
    //                         </div>`;
    //     let html='';
    //     list.forEach((row)=>{
    //         html+=render_template(tpl, row);
    //     });
    //     $('#modal_phone_jijung_list').html(html);
    // }
    /**
     * 연락처 그리기
     * @param list
     */
//     renderContact = function(list){
//         let tpl = `{cho}
// <div class="name_phone flex_space_between" onclick="$j.Ui.Window.handle.selectPhone('{cont_cel}','{cont_name}')">
//     <div class="name flex fz_13 fw_bolder">{cont_name}</div>
//     <div class="phone flex fz_13 fw_bolder">{cont_cel}</div>
// </div>`;
//         let html='';
//         let prevCho='';
//         list.forEach((row)=>{
//             //초성이 바뀌었는지
//             let cho='';
//             if( prevCho!=row['cho']) {
//                 let choShow=row['cho'];
//                 if(choShow=='하') choShow='123ABC';
//                 cho=`<div class="consonant flex fz_13">${choShow}</div>`;
//             }
//             prevCho=row['cho'];
//
//             row['cho']=cho;
//             row['cont_cel']=phoneNumber(row['cont_cel']);
//             row['cont_name']=row['cont_name'];
//             html+=render_template(tpl, row);
//         });
//         $('#modal_phone_contact_list').html(html);
//
//         this.initChoIdx();
//     }
    /**
     * 초성 인덱스를 만든다.
     */
    // initChoIdx = function() {
    //     let tpl = `<li class="flex"><a href="javascript:$j.Ui.Window.handle.scrollToCho('{cho}')">{cho}</a></li>`;
    //     let html = '';
    //     let arr = ['ㄱ','ㄴ','ㄷ','ㄹ','ㅁ','ㅂ','ㅅ','ㅇ','ㅈ','ㅊ','ㅋ','ㅌ','ㅍ','ㅎ','Z'];
    //     arr.forEach((v)=>{
    //         html+=render_template(tpl, {'cho':v});
    //     });
    //     $('#modal_phone_cho_idx').html(html);
    // }
    /**
     * 검색목록 그리기
     * @param list
     */
//     renderSearch =function(list){
//         let tpl = `
// <li class="flex_space_between" onclick="$j.Ui.Window.handle.selectPhone('{cont_cel}','{cont_name}',true)">
//     <div class="flex">
//         <img class="search_result_img" src="/img/sign/search_result_img.png"
//         srcset="/img/sign/search_result_img.png 1x,
//         /img/sign/search_result_img@2x.png 2x,
//         /img/sign/search_result_img@3x.png 3x,
//         /img/sign/search_result_img@4x.png 4x"
//         alt="magnify">
//         <div class="flex_column">
//             <div class="name fz_13 fw_bolder recent_txt_box">{cont_name2}<span class="recent_num_span">{cont_cel}</span></div>
//         </div>
//     </div>
// </li>`;
//         let html='';
//         list.forEach((row)=>{
//             row['cont_cel']=phoneNumber(row['cont_cel']);
//             row['cont_name2']=cutStr(row['cont_name'],10);
//             html+=render_template(tpl, row);
//         });
//         $('#modal_phone_search2 >ul').html(html);
//     }
    /**
     * 최근 이용 그리기
     * @param list
     */
    renderUse = function(list){
        let tpl = `
<li class="flex_space_between js-select-phone" data-phone="{cont_cel}" data-name="{cont_name}" data-apply="1">
    <div class="flex">
        <img class="recent_use_img" src="/img/sign/recent_use_img.png"
        srcset="/img/sign/recent_use_img.png 1x, 
        /img/sign/recent_use_img@2x.png 2x, 
        /img/sign/recent_use_img@3x.png 3x, 
        /img/sign/recent_use_img@4x.png 4x"
        alt="recent">
        <div class="flex_column">
            <div class="name fz_13 fw_bolder recent_txt_box">{cont_name2}<span class="recent_num_span">{cont_cel}</span></div>
        </div>
    </div>
</li>`;

        let html='';
        list.forEach((row)=>{
            row['cont_cel']=Util.escapeHtml(Util.phoneNumber(row['cont_cel']));
            row['cont_name2']=Util.escapeHtml(cutStr(row['cont_name'],10));
            row['cont_name']=Util.escapeHtml(row['cont_name']);
            html+=Util.render_template(tpl, row);
        });
        $('#modal_phone_search1 >ul').html(html);
    }
    /**
     * 소속기사,소유차량 그리기
     * @param data
     */
    renderCars = function(data){
        const drivers = data['d'];
        const cars = data['c'];
        let html = '';

        Object.keys(drivers).forEach((k)=>{
            html+=`
                    <li class="select_btn">
                        <button class="js-select-driver" data-value="${k}" data-name="${Util.escapeHtml(drivers[k])}">
                            <span>${Util.escapeHtml(drivers[k])}</span>
                        </button>
                    </li>`;
        });
        $('#modal_phone_drivers').html(html);

        html='';
        Object.keys(cars).forEach((k)=>{
            html+=`
                    <li class="select_btn">
                        <button class="js-select-car" data-value="${k}" data-name="${Util.escapeHtml(cars[k])}">
                            <span>${Util.escapeHtml(cars[k])}</span>
                        </button>
                    </li>`;
        });
        $('#modal_phone_cars').html(html);
    }
}
